/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export type Size = {
  xs?: number;
  sm: number;
  md: number;
  lg: number;
  xl?: number;
};

export interface TDictionary<T> {
  [index: string]: T;
}

export type FontWeightType =
  100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | "normal" | "bold";

export type FormLabelPosition = "top" | "left";

export enum ERequestStatus {
  IDLE = "idle",
  PENDING = "pending",
  FULFILLED = "fulfilled",
  REJECTED = "rejected",
  CANCELLED = "cancelled",
}
